import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { withRouter } from 'react-router-dom'
import LoaderButton from './loaderButton'

import { ReduxFormProps } from '../forms'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  onSubmit: Callback<Promise<any>>
  cancel: Callback
  onPriceChange: Callback
}

export interface FormProps {
  price: string
}

// eslint-disable-next-line
export class RefiProductForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  static displayName = 'EditLoanTermForm'

  render() {
    const { handleSubmit, submitting, cancel, onPriceChange } = this.props

    return (
      <div className="refi-product-form">
        <div className="refi-product-form__form">
          <form
            onSubmit={handleSubmit}
            className="form"
            data-test="refi-product-form"
          >
            <h2 className="refi-product-form__form__header--state">
              Add Product
            </h2>
            <hr className="form__hr refi-product-form__form__hr4" />
            <p>
              To add Gap insurance to this transaction, please enter the retail
              price below:
            </p>
            <div className="refi-product-form__form__state">
              <input type="text" name="retail_price" onChange={onPriceChange} />
            </div>
            <hr className="form__hr refi-product-form__form__hr5" />
            <div className="form__group refi-product-form__form__button">
              <LoaderButton
                className="button button--primary refi-product-form__form__button--submit"
                isLoading={submitting}
                disabled={submitting}
                data-test="refi-product-form-submit-button"
              >
                Save
              </LoaderButton>
              <a
                onClick={cancel}
                className="button button--secondary refi-product-form-edit__form__button--cancel"
                data-testid="refi-product-form-cancel-button"
                aria-label="cancel"
              >
                Cancel
              </a>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

const RefiProductFormWithRouter = reduxForm<FormProps, Props>({
  form: 'EditLoanTermForm',
})(RefiProductForm)

const selector = formValueSelector('EditLoanTermForm')
const RefiProductFormConnected = connect((state) => {
  const price = selector(state, 'price')
  return { price }
})(RefiProductFormWithRouter)

export default withRouter(RefiProductFormConnected)
